import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import classNames from 'classnames';

import { withStyles } from '@material-ui/core/styles';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import Typography from '@material-ui/core/Typography';

import Menu from 'components/common/Menu';
import DeleteMenu from 'components/common/DeleteMenu';
import Link from 'components/common/Link';

import formatUtcToLocalDate from 'utils/formatUtcToLocalDate';
import pxToRem from 'styles/pxToRem';

import dateFormat from 'config/dateFormat';
import timeDateFormat from 'config/timeDateFormat';

import { deletePatientVitals } from 'redux/modules/patientsVitals';

const styles = theme => ({
  tableRow: {
    height: 40,
  },
  tableCellRoot: {
    border: 'none',
    fontSize: pxToRem(14),
  },
  tableCellVitals: {
    width: 110,
    paddingRight: 10,
    whiteSpace: 'nowrap',
    [theme.breakpoints.down('sm')]: {
      width: 'auto',
    },
  },
  tableCellDate: {
    textAlign: 'center',
  },
  caption: {
    display: 'inline-block',
    marginRight: 8,
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  linkRemove: {
    paddingTop: 10,
    paddingBottom: 10,
  },
});

class VitalsItem extends Component {
  constructor(props) {
    super(props);

    this.state = {
      anchorEl: null,
    };

    this.onMenuClose = this.onMenuClose.bind(this);
    this.onRemoveButtonClick = this.onRemoveButtonClick.bind(this);
    this.onRemoveCancel = this.onRemoveCancel.bind(this);
    this.onRemoveSubmit = this.onRemoveSubmit.bind(this);
  }

  onMenuClose() {
    this.setState({ anchorEl: null });
  }

  onRemoveButtonClick(event) {
    this.setState({
      anchorEl: event.currentTarget,
    });
  }

  onRemoveCancel() {
    this.setState({ anchorEl: null });
  }

  onRemoveSubmit() {
    this.props.actions.deletePatientVitals({
      'Record Number': this.props['Record Number'],
      ID: this.props.ID,
    });
    this.setState({ anchorEl: null });
  }

  render() {
    const { business } = this.props;
    const open = Boolean(this.state.anchorEl);
    return (
      <TableRow className={this.props.classes.tableRow}>
        <TableCell
          padding="none"
          className={classNames(this.props.classes.tableCellRoot,
            this.props.classes.tableCellVitals)}
        >
          <Typography
            component="span"
            color="secondary"
            className={this.props.classes.caption}
          >
            Weight
          </Typography>
          {this.props.Weight} lb
        </TableCell>
        <TableCell
          padding="none"
          className={classNames(this.props.classes.tableCellRoot,
            this.props.classes.tableCellVitals)}
        >
          <Typography
            component="dt"
            color="secondary"
            className={this.props.classes.caption}
          >
            Height
          </Typography>
          {`${this.props['Height Ft']}ft, ${this.props['Height In']}in`}
        </TableCell>
        <TableCell
          padding="none"
          className={classNames(this.props.classes.tableCellRoot,
            this.props.classes.tableCellVitals)}
        >
          <Typography
            component="dt"
            color="secondary"
            className={this.props.classes.caption}
          >
            BMI
          </Typography>
          {this.props.BMI}
        </TableCell>
        <TableCell
          padding="none"
          className={classNames(this.props.classes.tableCellRoot,
            this.props.classes.tableCellDate)}
        >
          <Typography
            component="time"
            color="secondary"
            dateTime={formatUtcToLocalDate(
              this.props['Create At'],
              timeDateFormat,
              dateFormat,
              business['Company Address']['Time Zone'],
              business['Company Address']['Observes Daylight Saving'],
            )}
          >
            {formatUtcToLocalDate(
              this.props['Create At'],
              timeDateFormat,
              dateFormat,
              business['Company Address']['Time Zone'],
              business['Company Address']['Observes Daylight Saving'],
            )}
          </Typography>
        </TableCell>
        <TableCell
          padding="none"
          className={this.props.classes.tableCellRoot}
          numeric
        >
          <Link
            className={this.props.classes.linkRemove}
            color="primary"
            bold
            size="sm"
            aria-label="Remove"
            aria-owns={open ? `${this.props.ID}-vitals-remove-menu` : null}
            aria-haspopup="true"
            onClick={this.onRemoveButtonClick}
            disabled={this.props.account.Roles.filter(item =>
              item.Name === 'Master Administrator' || item.Name === 'Administrator' || item.Name === 'Manager').length === 0}
          >
            Remove
          </Link>
          <Menu
            id={`${this.props.ID}-vitals-remove-menu`}
            anchorEl={this.state.anchorEl}
            open={open}
            onClose={this.onMenuClose}
            list={false}
          >
            <DeleteMenu
              text="Are you sure you want to delete this vitals?"
              onCancel={this.onRemoveCancel}
              onSubmit={this.onRemoveSubmit}
            />
          </Menu>
        </TableCell>
      </TableRow>
    );
  }
}

VitalsItem.propTypes = {
  'Record Number': PropTypes.number.isRequired,
  ID: PropTypes.number.isRequired,
  'Create At': PropTypes.string,
  Weight: PropTypes.number.isRequired,
  'Height Ft': PropTypes.number.isRequired,
  'Height In': PropTypes.number.isRequired,
  BMI: PropTypes.number.isRequired,
  actions: PropTypes.shape({
    deletePatientVitals: PropTypes.func.isRequired,
  }).isRequired,
  account: PropTypes.shape({
    Roles: PropTypes.arrayOf(PropTypes.shape({
      Name: PropTypes.string.isRequired,
    })).isRequired,
  }).isRequired,
  business: PropTypes.shape({
    ID: PropTypes.number,
    'Time Zone': PropTypes.string,
  }),
  classes: PropTypes.shape({
    tableRow: PropTypes.string.isRequired,
    tableCellRoot: PropTypes.string.isRequired,
    tableCellVitals: PropTypes.string.isRequired,
    tableCellDate: PropTypes.string.isRequired,
    caption: PropTypes.string.isRequired,
    linkRemove: PropTypes.string.isRequired,
  }).isRequired,
};

VitalsItem.defaultProps = {
  'Create At': '',
  business: {},
};

const mapStateToProps = store => ({
  account: store.account,
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ deletePatientVitals }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(
  withStyles(styles)(VitalsItem),
);



// WEBPACK FOOTER //
// ./src/components/patient/PatientProfile/Vitals/VitalsItem.js